import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface FeaturedResourceProps {
  resource: {
    title: string;
    description: string;
    image: string;
    alt: string;
    category: string;
    downloadSize: string;
    downloads: number;
  };
}

export default function FeaturedResource({ resource }: FeaturedResourceProps) {
  return (
    <div className="relative bg-gradient-to-br from-secondary to-primary rounded-lg overflow-hidden border border-accent/30 hover:border-accent transition-all duration-300 hover:shadow-aerospace">
      <div className="absolute inset-0 bg-gradient-to-r from-accent/10 to-transparent"></div>
      
      <div className="relative grid md:grid-cols-2 gap-8 p-8">
        <div className="flex flex-col justify-center space-y-6">
          <div className="flex items-center space-x-3">
            <Icon name="StarIcon" variant="solid" size={24} className="text-accent" />
            <span className="font-cta text-sm text-accent tracking-wider">
              FEATURED RESOURCE
            </span>
          </div>

          <h2 className="font-headline text-3xl font-bold text-foreground">
            {resource.title}
          </h2>

          <p className="font-body text-base text-technical-gray leading-relaxed">
            {resource.description}
          </p>

          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Icon name="FolderIcon" size={20} className="text-accent" />
              <span className="font-body text-sm text-technical-gray">
                {resource.category}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="DocumentIcon" size={20} className="text-accent" />
              <span className="font-body text-sm text-technical-gray">
                {resource.downloadSize}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ArrowDownTrayIcon" size={20} className="text-accent" />
              <span className="font-body text-sm text-technical-gray">
                {resource.downloads} downloads
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button className="px-8 py-3 bg-accent text-primary font-cta text-sm rounded-lg hover:bg-accent/80 transition-all duration-300 hover:shadow-glow">
              DOWNLOAD NOW
            </button>
            <button className="px-8 py-3 bg-transparent border border-accent text-accent font-cta text-sm rounded-lg hover:bg-accent/10 transition-all duration-300">
              PREVIEW
            </button>
          </div>
        </div>

        <div className="relative h-80 md:h-auto rounded-lg overflow-hidden">
          <AppImage
            src={resource.image}
            alt={resource.alt}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent"></div>
        </div>
      </div>
    </div>
  );
}